import { useMutation } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { authApiClient } from '../../../api/axios';
import { showSnackbar } from '../../../api/snackbarSlice';

export const resendInvite = async (userId) => {
  const { data } = await authApiClient.post(`/users/${userId}/resend-invite`);
  return data;
};

export const useResendInviteHandler = () => {
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn: resendInvite,
    onSuccess: (data) => {
      dispatch(
        showSnackbar({
          message: data?.message || 'Invite resent successfully',
          severity: 'success',
        }),
      );
    },
    onError: (error) => {
      const message =
        error instanceof AxiosError
          ? error.response?.data?.errors?.message || error.message
          : 'Failed to resend invite';
      dispatch(showSnackbar({ message, severity: 'error' }));
    },
  });

  return {
    mutate: mutation.mutate,
    isPending: mutation.isPending,
  };
};
